import { useResolvedDesignSystemComponent } from 'ext-ui/design-system/DesignSystemChannel'
import GeneratedLatestMenuOptionTertiary, {
  MenuOptionTertiaryProps,
} from 'ext-ui/design-system/generated/latest/components/MenuOptionTertiary/MenuOptionTertiary'
import GeneratedLiveMenuOptionTertiary from 'ext-ui/design-system/generated/live/components/MenuOptionTertiary/MenuOptionTertiary'
import React, { ReactElement } from 'react'

function renderDesignSystemMenuOptionTertiary(
  Component: typeof GeneratedLiveMenuOptionTertiary,
  channel: 'live' | 'latest',
  props: MenuOptionTertiaryProps,
): ReactElement {
  return <Component {...props} data-design-system-channel={channel} />
}

function LiveMenuOptionTertiary(props: MenuOptionTertiaryProps): ReactElement {
  return renderDesignSystemMenuOptionTertiary(
    GeneratedLiveMenuOptionTertiary,
    'live',
    props,
  )
}

function LatestMenuOptionTertiary(
  props: MenuOptionTertiaryProps,
): ReactElement {
  return renderDesignSystemMenuOptionTertiary(
    GeneratedLatestMenuOptionTertiary,
    'latest',
    props,
  )
}

function MenuOptionTertiary(props: MenuOptionTertiaryProps): ReactElement {
  const ResolvedMenuOptionTertiary = useResolvedDesignSystemComponent(
    LiveMenuOptionTertiary,
    LatestMenuOptionTertiary,
  )

  return <ResolvedMenuOptionTertiary {...props} />
}

export default MenuOptionTertiary
export type { MenuOptionTertiaryProps }
